module.exports = __webpack_public_path__ + "search.svg";